// This relationship obviously isn't quite right, but this is referencing the legacy app state
// better to move it and dela with this coupling later.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { RangeValueFilterControlJs, ReportFilterControlJs } from '@mode/filters/util';
import { ReportTypes } from '@mode/shared/contract-common';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FilterPanelActions {
  export enum Type {
    ToggleFilterPanel = 'panel.toggleFilterPanel',
    ApplyFilters = 'panel.applyFilters',
    ApplyFiltersAndGenerateLink = 'panel.applyFiltersAndGenerateLink',
    ResetFilters = 'panel.resetFilters',
    ResetFilter = 'panel.resetFilter',
    SetAsDefault = 'panel.setAsDefault',
    DeleteFilter = 'panel.deleteFilter',
    MoveFilter = 'panel.moveFilter',
    MoveFilterToBottom = 'panel.moveFilterToBottom',
    FilterSelectionChange = 'panel.filterSelectionChange',
    SetFilterType = 'panel.setFilterType',
    SetSelectionControlType = 'panel.setSelectionControlType',
    SetRangeIncludeNulls = 'panel.setRangeIncludeNulls',
    SetHideSelectAll = 'panel.setHideSelectAll',
    ShowRelevantValues = 'panel.showRelevantValues',
    FilterPanelLoaded = 'panel.FilterPanelLoaded',
  }

  export class ToggleFilterPanel {
    readonly type = Type.ToggleFilterPanel;

    constructor(public readonly isOpen: boolean) {}
  }

  export class ApplyFilters {
    readonly type = Type.ApplyFilters;

    constructor(public readonly filters: ReportFilterControlJs[]) {}
  }

  export class ApplyFiltersAndGenerateLink {
    readonly type = Type.ApplyFiltersAndGenerateLink;

    constructor(public readonly filters: ReportFilterControlJs[]) {}
  }
  export class ResetFilters {
    readonly type = Type.ResetFilters;

    constructor(public readonly filters: ReportFilterControlJs[]) {}
  }

  export class ResetFilter {
    readonly type = Type.ResetFilter;

    constructor(public readonly filter: ReportFilterControlJs) {}
  }

  export class SetAsDefault {
    readonly type = Type.SetAsDefault;

    constructor(public readonly filters: ReportFilterControlJs[]) {}
  }

  export class DeleteFilter {
    readonly type = Type.DeleteFilter;

    constructor(public readonly filter: ReportFilterControlJs) {}
  }

  export class MoveFilter {
    readonly type = Type.MoveFilter;

    constructor(
      public readonly filter: ReportFilterControlJs,
      public readonly nextToken: string
    ) {}
  }

  export class MoveFilterToBottom {
    readonly type = Type.MoveFilterToBottom;

    constructor(public readonly filter: ReportFilterControlJs) {}
  }

  export class SetFilterType {
    readonly type = Type.SetFilterType;

    constructor(
      public readonly filter: ReportFilterControlJs,
      public readonly filterType: ReportTypes.ReportFilterType,
      public readonly applyFilters: boolean,
      public readonly defaultSelection?: ReportTypes.FilterSelection
    ) {}
  }

  export class SetSelectionControlType {
    readonly type = Type.SetSelectionControlType;

    constructor(
      public readonly filter: ReportFilterControlJs,
      public readonly controlType: ReportTypes.SelectControlType
    ) {}
  }

  export class SetRangeIncludeNulls {
    readonly type = Type.SetRangeIncludeNulls;

    constructor(
      public readonly filter: RangeValueFilterControlJs,
      public readonly includeNulls: boolean
    ) {}
  }

  export class SetHideSelectAll {
    readonly type = Type.SetHideSelectAll;

    constructor(
      public readonly filter: ReportFilterControlJs,
      public readonly hideSelectAll: boolean,
      public readonly selection?: ReportTypes.FilterValueSelection,
      public readonly persist = false
    ) {}
  }
  export class FilterSelectionChange {
    readonly type = Type.FilterSelectionChange;

    constructor(
      public readonly token: string,
      public readonly selection: ReportTypes.FilterSelection
    ) {}
  }

  export class ShowRelevantValues {
    readonly type = Type.ShowRelevantValues;

    constructor(
      public readonly filterToken: string,
      public showRelevantValues: boolean
    ) {}
  }

  export class FilterPanelLoaded {
    readonly type = Type.FilterPanelLoaded;

    constructor() {}
  }

  export type Actions =
    | ToggleFilterPanel
    | ApplyFilters
    | ApplyFiltersAndGenerateLink
    | ResetFilters
    | ResetFilter
    | SetAsDefault
    | DeleteFilter
    | MoveFilter
    | MoveFilterToBottom
    | SetFilterType
    | SetSelectionControlType
    | SetRangeIncludeNulls
    | SetHideSelectAll
    | FilterSelectionChange
    | ShowRelevantValues
    | FilterPanelLoaded;
}
